export const uploadToS3 = async (
  bucket: string,
  file: File,
  signedURL: string,
) => {
  try {
    // Put image in the S3 bucket
    const response = await fetch(signedURL, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": file.type,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to upload file to S3");
    }

    // Return the URL of the uploaded file
    return signedURL;
  } catch (error) {
    console.error("Error uploading file to S3:", error);
    throw error;
  }
};

// Function to handle image uploads
export const getImageUpload = async (file: File, signedURL: string) => {
  try {
    const image = await uploadToS3("image", file, signedURL);
    const imageUrl = image.split("?")[0];
    console.log("Image succesfully uploaded");
    return imageUrl;
  } catch (error) {
    console.error("Image upload failed:", error);
    throw error;
  }
};

// Function to handle file uploads
export const getFileUpload = async (file: File, signedURL: string) => {
  if (file.type.includes("image/")) {
    return await getImageUpload(file, signedURL);
  }
  try {
    const f = await uploadToS3("file", file, signedURL);
    const fileUrl = f.split("?")[0];
    console.log("File succesfully uploaded");
    return fileUrl;
  } catch (error) {
    console.error("File upload failed:", error);
    throw error; // Rethrow the error for further handling
  }
};

interface Props {
  urls: {
    awsImageUrls: string[];
    setAwsImageUrls: React.Dispatch<React.SetStateAction<string[]>>;
    awsFileUrls: string[];
    setAwsFileUrls: React.Dispatch<React.SetStateAction<string[]>>;
  };
}

// Check if the content contains URLs from awsImageUrls or awsFileUrls and delete from S3 bucket.
export const containsAwsUrls = async (
  content: string,
  urls: Props["urls"],
  removeFromBucket: (fileUrl: string, bucket: string) => Promise<boolean>,
): Promise<void> => {
  const { awsImageUrls, setAwsImageUrls, awsFileUrls, setAwsFileUrls } = urls;

  const remove = async (
    bucket: string,
    setUrls: React.Dispatch<React.SetStateAction<string[]>>,
    url: string,
  ) => {
    await removeFromBucket(url, bucket);
    setUrls((prevUrls) => prevUrls.filter((item) => item !== url));
  };

  // Iterate through each URL and check if it exists in the content
  for (const url of awsImageUrls) {
    if (!content.includes(url)) {
      await remove("image", setAwsImageUrls, url);
    }
  }
  for (const url of awsFileUrls) {
    if (!content.includes(url)) {
      await remove("file", setAwsFileUrls, url);
    }
  }
};
